// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullChampionshipResultTableRace,
  $ModelUpsertParams,
  $RegattaResource,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputCheckbox,
  InputNumber,
} from '@vroskus/library-components';

// Types
type $Props = $Translate & {
  item: $FullChampionshipResultTableRace | $ModelUpsertParams<'ChampionshipResultTableRace'>;
  resourceData: Array<$RegattaResource>;
};

const ChampionshipResultTableRaceFieldsView = function ({
  item,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={12}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <AvField
            label={t('Slug')}
            maxLength={'6'}
            name={'Slug'}
            required
            value={item.Slug}
          />
        </Col>
        <Col xs={6}>
          <InputNumber
            label={t('Coef')}
            min={0}
            name={'Coef'}
            required
            value={item.Coef}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputCheckbox
            label={t('Undiscard')}
            name={'Undiscard'}
            value={item.Undiscard}
          />
        </Col>
        <Col>
          <InputCheckbox
            label={t('Dominant')}
            name={'Dominant'}
            value={item.Dominant}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Regatta')}
            name={'RegattaId'}
            type={'select'}
            value={item.RegattaId}
          >
            {item.RegattaId === '' && (
              <option />
            )}
            {resourceData.map((i) => (
              <option
                key={i.id}
                value={i.id}
              >
                {i.Name}
              </option>
            ))}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default ChampionshipResultTableRaceFieldsView;
